import Action from './baseActions';

export enum SubscriptionActionTypes {
  START_TRIAL = 'subscription/start_trial',
  STARTING_TRIAL = 'subscription/starting_trial',
  STARTED_TRIAL = 'subscription/started_trial',
  STARTING_TRIAL_FAILED = 'subscription/starting_trial_failed',

  // stripe products with prices
  LOAD_PRODUCTS = 'subscription/load_products',
  LOADING_PRODUCTS = 'subscription/loading_products',
  LOADED_PRODUCTS = 'subscription/loaded_products',
  LOADING_PRODUCTS_FAILED = 'subscription/loading_products_failed',
}

// Interfaces

export interface IStartTrialAction extends Action {
  type: SubscriptionActionTypes.START_TRIAL;
}

export interface IStartingTrialAction extends Action {
  type: SubscriptionActionTypes.STARTING_TRIAL;
}

export interface IStartedTrialAction extends Action {
  type: SubscriptionActionTypes.STARTED_TRIAL;
}

export interface IStartingTrialFailedAction extends Action {
  type: SubscriptionActionTypes.STARTING_TRIAL_FAILED;
}

export interface ILoadProductsAction extends Action {
  type: SubscriptionActionTypes.LOAD_PRODUCTS;
}

export interface ILoadingProductsAction extends Action {
  type: SubscriptionActionTypes.LOADING_PRODUCTS;
}

export interface ILoadedProductsAction extends Action {
  type: SubscriptionActionTypes.LOADED_PRODUCTS;
  payload: any;
}

export interface ILoadingProductsFailedAction extends Action {
  type: SubscriptionActionTypes.LOADING_PRODUCTS_FAILED;
}

// Functions

export function startTrial(): IStartTrialAction {
  return {
    type: SubscriptionActionTypes.START_TRIAL,
  };
}

export function startingTrial(): IStartingTrialAction {
  return {
    type: SubscriptionActionTypes.STARTING_TRIAL,
  };
}

export function startedTrial(): IStartedTrialAction {
  return {
    type: SubscriptionActionTypes.STARTED_TRIAL,
  };
}

export function startingTrialFailed(): IStartingTrialFailedAction {
  return {
    type: SubscriptionActionTypes.STARTING_TRIAL_FAILED,
  };
}

export function loadProducts(): ILoadProductsAction {
  return {
    type: SubscriptionActionTypes.LOAD_PRODUCTS,
  };
}

export function loadingProducts(): ILoadingProductsAction {
  return {
    type: SubscriptionActionTypes.LOADING_PRODUCTS,
  };
}

export function loadedProducts(payload: any): ILoadedProductsAction {
  return {
    type: SubscriptionActionTypes.LOADED_PRODUCTS,
    payload,
  };
}

export function loadingProductsFailed(): ILoadingProductsFailedAction {
  return {
    type: SubscriptionActionTypes.LOADING_PRODUCTS_FAILED,
  };
}

export type SubscriptionActions =
  | IStartTrialAction
  | IStartingTrialAction
  | IStartedTrialAction
  | IStartingTrialFailedAction
  | ILoadProductsAction
  | ILoadingProductsAction
  | ILoadedProductsAction
  | ILoadingProductsFailedAction;
